import { useState, useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import BefeniLogo from "../assets/images/befenilogo.svg";
import Cloth from "../assets/images/cloth.svg";
import DownChevron from "../assets/images/down-chevron.svg";
import Textiles from "../assets/images/textiles.svg";
import PatternSolid from "../assets/images/pattern-solid.png";
import PatternStripe from "../assets/images/pattern-stripe.png";
import PatternChecked from "../assets/images/pattern-checked.png";
import Pattern from "../assets/images/pattern-geometric.jpg";
import PatternFlowered from "../assets/images/pattern-flowered.png";
import PatternDots from "../assets/images/pattern-dots.png";
import PatternCamo from "../assets/images/pattern-camo.png";
import PatternOther from "../assets/images/pattern-other.png";
import PatternHerringbone from "../assets/images/pattern-herringbone.jpeg";
import PatternDobby from "../assets/images/pattern-dobby.jpg";
import PatternAbstract from "../assets/images/pattern-abstract.jpg";
import Filter from "../assets/images/filter.svg";
import Wishlist from "../assets/images/wishlist.svg";
import Home from "../assets/images/home.svg";
import Cart from "../assets/images/cart.svg";
import User from "../assets/images/user.svg";
import Cancel from "../assets/images/cancel.svg";
import FlagEn from "../assets/images/flag_en.png";
import FlagDe from "../assets/images/flag_de.png";
import MobileMenu from "./mobileMenu/MobileMenu";
import LoginModal from "./loginModal/LoginModal";
import AdvancedFilters from "./advancedFilters/AdvancedFilters";
import SelectButton from "./SelectButton";
import { changePage, getShirts, showLoginModal } from "../actions/GalleryActions";
import { useTranslation } from "react-i18next";
import axios from "axios";

const patternMenu = [{
  name: "filter_options.solid",
  image: PatternSolid,
  value: "solid"
}, {
  name: "filter_options.striped",
  image: PatternStripe,
  value: "striped"
}, {
  name: "filter_options.checked",
  image: PatternChecked,
  value: "checked"
}, {
  name: "filter_options.geometric",
  image: Pattern,
  value: "geometric"
}, {
  name: "filter_options.floral",
  image: PatternFlowered,
  value: "floral"
}, {
  name: "filter_options.dotted",
  image: PatternDots,
  value: "dotted"
}, {
  name: "filter_options.camouflage",
  image: PatternCamo,
  value: "camouflage"
}, {
  name: "filter_options.herringbone",
  image: PatternHerringbone,
  value: "herringbone"
}, {
  name: "filter_options.dobby",
  image: PatternDobby,
  value: "dobby"
}, {
  name: "filter_options.abstract",
  image: PatternAbstract,
  value: "abstract"
}, {
  name: "filter_options.other",
  image: PatternOther,
  value: "other"
},];

const designMenu = [{
  name: 'filter_options.plain',
  value: "solid"
}, {
  name: 'filter_options.with_contrast_fabric',
  value: "contrast"
},];

const sortMenu = [{
  name: 'filter_options.by_popularity',
  value: "likes"
}, {
  name: 'filter_options.by_latest',
  value: "gallery_added_date"
},];

function Nav() {
  const [ t ] = useTranslation();
  const { i18n } = useTranslation();

  const dispatch = useDispatch();
  const config = useSelector(({ Gallery }) => Gallery?.config);
  const showLogin = useSelector(({ Gallery }) => Gallery?.showLogin);
  const currentPage = useSelector(({ Gallery }) => Gallery?.currentPage);
  const user = useSelector(({ Gallery }) => Gallery?.user);
  const tokenReady = useSelector(({ Gallery }) => Gallery?.tokenReady);

  const [contrastColorsMenu, setcontrastColorsMenu] = useState([]);
  const [colorsMenu, setColorsMenu] = useState([]);
  const [compMenu, setCompMenu] = useState([]);
  const [weaveMenu, setWeaveMenu] = useState([]);
  const [collarMenu, setCollarMenu] = useState([]);
  const [cuffMenu, setCuffMenu] = useState([]);
  const [fabricMenu, setFabricMenu] = useState([]);
  const [colors, setColors] = useState();
  const [design, setDesign] = useState();
  const [pattern, setPattern] = useState();
  const [fabric, setFabric] = useState([]);
  const [contrastColorsSelection, setContrastColorsSelection] = useState([]);
  const [colorsSelection, setColorsSelection] = useState([]);
  const [compSelection, setCompSelection] = useState([]);
  const [weaveSelection, setWeaveSelection] = useState([]);
  const [collarSelection, setCollarSelection] = useState([]);
  const [cuffSelection, setCuffSelection] = useState([]);
  const [sort, setSort] = useState();
  const [sortType, setSortType] = useState("desc");
  const [sotwOnly, setSotwOnly] = useState(window.showSotwByDefault);
  const [per_page] = useState(21);
  const [clearFiltersBtn, setClearFiltersBtn] = useState(false);
  const [login, setLogin] = useState(false);
  const [mobileMenuState, setMobileMenuState] = useState(false);
  const [showAdvanced, setShowAdvanced] = useState(false);
  const [wishlistView, setWishlistView] = useState(false);

  useEffect(() => {
    if (tokenReady) {
      dispatch(getShirts({
        colors,
        design,
        pattern,
        fabric,
        sort,
        sortType,
        sotw_only: sotwOnly,
        page: currentPage,
        per_page,
        collar: collarSelection,
        cuff: cuffSelection,
        weave: weaveSelection,
        compositions: compSelection,
        family: colorsSelection,
        contrast_family: contrastColorsSelection,
        wishlistView
      }));
    }
  },
    [tokenReady, colors, design, dispatch, fabric, pattern, per_page, sort, sortType, sotwOnly, currentPage, collarSelection, cuffSelection, weaveSelection, compSelection, colorsSelection, contrastColorsSelection, wishlistView],
  )

  useEffect(() => {
    setFabricMenu(config?.fabrics);
    setcontrastColorsMenu(config?.contrast_fabric_families);
    setColorsMenu(config?.fabric_families);
    setCompMenu(config?.fabric_compositions);
    setWeaveMenu(config?.weave);
    setCollarMenu(config?.collar_types);
    setCuffMenu(config?.cuff_types);
  }, [config])

  useEffect(() => {
    setLogin(showLogin);
  }, [showLogin])

  const checkIfLoggedIn = () => {
    if (user.status === false) {
      dispatch(showLoginModal(true))
      return false;
    } else {
      return true
    }
  }

  const setInitialFabricFilter = () => {

    if(window.fabricFilter.length > 0 && config.fabrics) {
      let fabrics = config.fabrics.filter(entry => {
        return entry.name.toLowerCase() === window.fabricFilter.toLowerCase();
      });
      if(fabrics) {
        setFabric(fabrics.map(f => f.id));
      }
      // Clear the initial filter
      window.fabricFilter = '';
    }
  }

  useEffect(() => {
    if(config) {
      setInitialFabricFilter()
    }
  }, [config])

  const updateFilterValue = useCallback(
    (field, value) => {
      document.querySelector(".list-container").scrollTo(0, 0);
      switch (field) {
        case "fabric":
          if (!fabric?.includes(value)) {
            setFabric(fabric?.length > 0 ? [...fabric, value] : [value]);
          } else {
            setFabric(fabric?.filter(entry => entry !== value))
          }
          break;
        case "contrast-color":
          if (!contrastColorsSelection?.includes(value)) {
            setContrastColorsSelection(contrastColorsSelection?.length > 0 ? [...contrastColorsSelection, value] : [value]);
          } else {
            setContrastColorsSelection(contrastColorsSelection?.filter(entry => entry !== value))
          }
          break;
        case "composition":
          if (!compSelection?.includes(value)) {
            setCompSelection(compSelection?.length > 0 ? [...compSelection, value] : [value]);
          } else {
            setCompSelection(compSelection?.filter(entry => entry !== value))
          }
          break;
        case "weave":
          if (!weaveSelection?.includes(value)) {
            setWeaveSelection(weaveSelection?.length > 0 ? [...weaveSelection, value] : [value]);
          } else {
            setWeaveSelection(weaveSelection?.filter(entry => entry !== value))
          }
          break;
        case "collar":
          if (!collarSelection?.includes(value)) {
            setCollarSelection(collarSelection?.length > 0 ? [...collarSelection, value] : [value]);
          } else {
            setCollarSelection(collarSelection?.filter(entry => entry !== value))
          }
          break;
        case "cuff":
          if (!cuffSelection?.includes(value)) {
            setCuffSelection(cuffSelection?.length > 0 ? [...cuffSelection, value] : [value]);
          } else {
            setCuffSelection(cuffSelection?.filter(entry => entry !== value))
          }
          break;
        case "colors":
          if (!colorsSelection?.includes(value)) {
            setColorsSelection(colorsSelection?.length > 0 ? [...colorsSelection, value] : [value]);
          } else {
            setColorsSelection(colorsSelection?.filter(entry => entry !== value))
          }
          break;
        case "pattern":
          setPattern(value);
          break;
        case "sort":
          setSort(value);
          break;
        case "design":
          setDesign(value);
          break;
        case "sotw":
          setSotwOnly(value)
          break;
        default:
          break;
      }
      setClearFiltersBtn(true);
      dispatch(changePage(1))
    },
    [collarSelection, colorsSelection, compSelection, contrastColorsSelection, cuffSelection, dispatch, fabric, weaveSelection],
  );

  const clearFilters = useCallback(
    () => {
      setColors()
      setDesign()
      setPattern()
      setFabric([])
      setContrastColorsSelection([])
      setColorsSelection([])
      setCompSelection([])
      setWeaveSelection([])
      setCollarSelection([])
      setCuffSelection([])
      setSort()
      setSotwOnly(false)
      setClearFiltersBtn(false)
      dispatch(changePage(1))
      document.querySelector(".list-container").scrollTo(0, 0);
    },
    [dispatch],
  )

  const changeLanguageContainer = <>
    <img onClick={() => changeLanguage('de')} src={FlagDe} alt="German" className="change-language german"/>
    <img onClick={() => changeLanguage('en')} src={FlagEn} alt="English" className="change-language"/>
  </>

  async function changeLanguage(lang) {
    i18n.changeLanguage(lang);
    await axios.post('/hello.php?language=' + lang)
  }

  return (
    <div className="filters">
      <a href="/">
        <img src={BefeniLogo} alt="" />
      </a>
      <div className="center">
        <SelectButton icon={Cloth} chevron={DownChevron} title={t('filters.fabric_name')} panelType="searchDD" data={fabricMenu} desktop="medium" updateFilterValue={updateFilterValue} selectedInps={fabric} />
        <SelectButton icon={Textiles} chevron={DownChevron} title={t('filters.pattern')} panelType="imagesDD" data={patternMenu} desktop="medium" updateFilterValue={updateFilterValue} selectedInps={pattern} />
        <SelectButton icon={Cloth} chevron={DownChevron} title={t('filters.design')} panelType="radioDD" data={designMenu} desktop="big" radioName="design" updateFilterValue={updateFilterValue} selectedInps={design} />
        <SelectButton chevron={DownChevron} title={t('filters.order')} panelType="radioDD" data={sortMenu} desktop="big" radioName="sort" updateFilterValue={updateFilterValue} selectedInps={sort} />
        <div className={"sotw-filter-btn " + (sotwOnly ? "active" : null)} onClick={() => updateFilterValue("sotw", !sotwOnly)}>
          {sotwOnly ?
            <img src={Cancel} alt="" />
            : null}
          {" "}{t('filters.shirt_of_the_week')}
        </div>
        <div className="filter more-tools" onClick={() => setMobileMenuState(true)}>
          <img src={Filter} alt="" />
          <span>{t('filters.more')} </span> {t('filters.filter')}
        </div>
        <div className={"filter adv-tools " + (contrastColorsSelection.length || colorsSelection.length || compSelection.length || weaveSelection.length || collarSelection.length || cuffSelection.length ? "active" : null)} onClick={() => { setShowAdvanced(true) }}>
          {t('filters.advanced_filter')}
        </div>
        {clearFiltersBtn ?
          <div className="clear-filters-btn" onClick={() => clearFilters()}>
            {t('filters.reset_filter')}
          </div> :
          null
        }
      </div>
      <div className="right">
        <img className="show-wishlist active" src={!wishlistView ? Wishlist : Home} alt="" onClick={() => {
          if (!checkIfLoggedIn()) { return }
          dispatch(changePage(1));
          setWishlistView(!wishlistView);
          document.querySelector(".list-container").scrollTo(0, 0);
        }} />
        {
          !user.status ?
            <img className="cart" src={Cart} alt="" onClick={() => checkIfLoggedIn()} />
            :
            <a href={!user.is_client ? "/cart.php" : "/shop/cart.php"}>
              <img className="cart" src={Cart} alt="" />
            </a>
        }
        {
          !user.status ?
            <img className="user-icon" src={User} alt="" onClick={() => checkIfLoggedIn()} />
            :
            <a href={!user.is_client ? "/welcome.php" : "/shop/myorders.php"}>
              <img className="user-icon" src={User} alt="" />
            </a>
        }
        { changeLanguageContainer }

      </div>

      {showAdvanced ?
        <AdvancedFilters
          closeAdvanced={() => setShowAdvanced(false)}
          clearFilters={() => clearFilters()}
          contrastColorsMenu={contrastColorsMenu}
          colorsMenu={colorsMenu}
          compMenu={compMenu}
          weaveMenu={weaveMenu}
          collarMenu={collarMenu}
          cuffMenu={cuffMenu}
          fabricMenu={fabricMenu}
          updateFilterValue={updateFilterValue}
          fabric={fabric}
          contrastColorsSelection={contrastColorsSelection}
          colorsSelection={colorsSelection}
          compSelection={compSelection}
          weaveSelection={weaveSelection}
          collarSelection={collarSelection}
          cuffSelection={cuffSelection}
        />
        : null
      }

      {mobileMenuState ?
        <MobileMenu closeMenu={() => setMobileMenuState(false)}
          clearFilters={() => clearFilters()}
          fabricMenu={fabricMenu}
          patternMenu={patternMenu}
          patternSelection={pattern}
          designMenu={designMenu}
          sortMenu={sortMenu}
          updateFilterValue={updateFilterValue}
          selectedInps={fabric}
          sortType={sortType}
          setSortType={setSortType} />
        : null
      }

      {login ?
        <LoginModal />
        : null}
    </div>
  );
}

export default Nav